import { render, staticRenderFns } from "./PartCostContent.vue?vue&type=template&id=4ca8f9b2&"
import script from "./PartCostContent.vue?vue&type=script&lang=js&"
export * from "./PartCostContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports